/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getJson } from 'session';

import { Acl } from 'modules/common/components/Acl';
import TabContainer from './applications/traffic-violators/TabContainer';
import TransactionsContainer from './dashboard/TransactionsContainer';
import OVRSSettings from '../../general-settings/ovrs/OVRSSettings';
import ReportsContainer from './reports/ReportsContainer';

function CIRSContainer({ match }) {
  const permissions = getJson('permissions');
  return (
    <div className="module-inner">
      <div className="module-inner-title">Ordinance Violation Receipts</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW OVRS']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/ordinance-violation-receipts"
          >
            Dashboard
          </NavLink>
        )}
        {Acl(permissions, ['VIEW OVRS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/ordinance-violation-receipts/violations"
          >
            Applications
          </NavLink>
        )}
        {Acl(permissions, ['VIEW OVRS SETTINGS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/ordinance-violation-receipts/settings"
          >
            Settings
          </NavLink>
        )}
        {Acl(permissions, ['VIEW OVRS REPORTS TAB']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/ordinance-violation-receipts/reports"
          >
            Reports
          </NavLink>
        )}
      </div>
      <Switch>
        <Route exact path={`${match.path}`} component={TransactionsContainer} />
        <Route path={`${match.path}/violations`} component={TabContainer} />
        <Route path={`${match.path}/settings`} component={OVRSSettings} />
        <Route path={`${match.path}/reports`} component={ReportsContainer} />
      </Switch>
    </div>
  );
}

CIRSContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(CIRSContainer);
